// Escopo GLOBAL dos jogos

export default {
  data() {
    return {
      placeholderData: "dd/mm/aaaa",
      idiomas: [
        { key: "Português", value: "pt" },
        { key: "Inglês", value: "en" },
        { key: "Espanhol", value: "es" },
      ],
      status: [
        { text: "Ativo", value: "ATIVO" },
        { text: "Inativo", value: "INATIVO" },
      ],
      pessoa: [
        // { text: "Jurídica", value: "JURIDICA" },
        { text: "Física", value: "FISICA" },
      ],
      headers: [
        // {
        //     text: 'Seleção',
        //     align: 'center',
        //     sortable: true,
        //     value: 'sku',
        //     select: true
        // },
        {
          text: "Nome", // Nome/Razão Social
          align: "center",
          sortable: true,
          value: "nome",
          width: 120,
        },
        {
          text: "E-mail",
          align: "center",
          sortable: true,
          value: "email",
          width: 120,
        },
        {
          text: "Data do cadastro",
          align: "center",
          sortable: true,
          value: "ins_dthr",
          width: 160,
        },
        {
          text: "Tipo de Pessoa",
          align: "center",
          sortable: true,
          value: "tipo_pessoa",
          width: 180,
        },
        {
          text: "CPF/Passaporte",
          align: "center",
          sortable: true,
          value: "documento",
          width: 160,
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
          width: 120,
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
    };
  },

  methods: {
    consumerTab(tab) {
      switch (tab.title) {
        case "Dados Cadastrais":
          document.getElementsByClassName(
            "pessoas-consumidor-dados-cadastrais"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-consumidor-endereco"
          )[0].style.display = "none";
          document.getElementsByClassName("endr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("endr")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-consumidor-empresa"
          )[0].style.display = "none";
          document.getElementsByClassName("empr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("empr")[0].style.color = "#000";
          break;

        case "Endereço":
          document.getElementsByClassName(
            "pessoas-consumidor-endereco"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-consumidor-dados-cadastrais"
          )[0].style.display = "none";
          document.getElementsByClassName("dadosCad")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("dadosCad")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-consumidor-empresa"
          )[0].style.display = "none";
          document.getElementsByClassName("empr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("empr")[0].style.color = "#000";
          break;

        case "Empresa":
          document.getElementsByClassName(
            "pessoas-consumidor-empresa"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-consumidor-dados-cadastrais"
          )[0].style.display = "none";
          document.getElementsByClassName("dadosCad")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("dadosCad")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-consumidor-endereco"
          )[0].style.display = "none";
          document.getElementsByClassName("endr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("endr")[0].style.color = "#000";
          break;

        default:
          document.getElementsByClassName(
            "pessoas-agentes-dados-cadastrais"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-consumidor-endereco"
          )[0].style.display = "none";
          document.getElementsByClassName("endr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("endr")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-consumidor-empresa"
          )[0].style.display = "none";
          document.getElementsByClassName("empr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("empr")[0].style.color = "#000";
          break;
      }
    },
    exportarConsumidores() {
      let csvHeader = "";
      let csvRows = "";
      let finalCsv = "";
      const processHeader = data => {
        let finalValue = "";
        for (var j = 0; j < data.length; j++) {
          if (data[j].text != "Ações" && data[j].text != "Status") {
            finalValue += data[j].text + ",";
          }
        }
        finalValue += "Celular,País,Estado,Cidade,Status\n";

        return finalValue;
      };

      csvHeader = processHeader(this.headers);

      const processRow = data => {
        let rows = "";
        data.forEach(element => {
          if (element.tipo_pessoa == "JURIDICA") {
            rows +=
              element.razao_social +
              "," +
              element.email +
              "," +
              this.$config.convertDataBR(element.ins_dthr.substring(0, 10)) +
              "," +
              element.tipo_pessoa +
              "," +
              element.cnpj +
              "," +
              element.celular +
              "," +
              element.end_pais +
              "," +
              element.end_estado +
              "," +
              element.end_cidade +
              "," +
              element.status +
              "\n";
          } else {
            rows +=
              element.nome +
              "," +
              element.email +
              "," +
              this.$config.convertDataBR(element.ins_dthr.substring(0, 10)) +
              "," +
              element.tipo_pessoa +
              "," +
              element.documento +
              "," +
              element.celular +
              "," +
              element.end_pais +
              "," +
              element.end_estado +
              "," +
              element.end_cidade +
              "," +
              element.status +
              "\n";
          }
        });

        return rows;
      };

      if (this.exportar == "todos_consumidores") {
        csvRows = processRow(this.$marketplace_consumidor.consumidores);
      } else {
        if (this.$marketplace_consumidor.select_consumidores.length == 0) {
          this.$config.alert(
            "Selecione um consumidor para exportar",
            this.$config.dados.errorColor
          );
          return;
        }

        csvRows = processRow(this.$marketplace_consumidor.select_consumidores);
      }

      finalCsv = csvHeader + csvRows;

      var blob = new Blob([finalCsv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, "consumidores");
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", "consumidores");
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }

      this.closeModal();

      this.exportar = "todos_consumidores";
      this.$marketplace_consumidor.select_consumidores = [];
    },
    goToConsumer(type, data) {
      this.$marketplace_consumidor.consumidorAddOrEdit = type;

      if (type === "editar") {
        this.$router.push({
          name: "marketPlaceConsumerSettings",
          params: { type: "editar" },
        });
        this.$marketplace_consumidor.cadastro.id_marketplace =
          data.idmarketplace;
        this.$marketplace_consumidor.cadastro.dados_cadastrais.pessoa =
          data.tipo_pessoa;
        this.$marketplace_consumidor.cadastro.dados_cadastrais.id =
          data.idconsumidor;

        this.$marketplace_consumidor.cadastro.dados_cadastrais.email =
          data.email;
        this.$marketplace_consumidor.cadastro.dados_cadastrais.celular =
          data.celular;
        this.$marketplace_consumidor.cadastro.dados_cadastrais.idioma =
          data.idioma;
        this.$marketplace_consumidor.cadastro.dados_cadastrais.status =
          data.status;

        if (data.imagem) {
          this.$marketplace_consumidor.cadastro.dados_cadastrais.foto.imagem =
            data.imagem;
          this.$marketplace_consumidor.cadastro.dados_cadastrais.foto.have = true;
        }

        this.$marketplace_consumidor.cadastro.dados_cadastrais.pais =
          data.end_pais;
        this.$marketplace_consumidor.cadastro.dados_cadastrais.end_numero =
          data.end_numero;
        this.$marketplace_consumidor.cadastro.dados_cadastrais.estado =
          data.end_estado;
        this.$marketplace_consumidor.cadastro.dados_cadastrais.cidade =
          data.end_cidade;
        this.$marketplace_consumidor.cadastro.dados_cadastrais.cep =
          data.end_cep;
        this.$marketplace_consumidor.cadastro.dados_cadastrais.bairro =
          data.end_bairro;
        this.$marketplace_consumidor.cadastro.dados_cadastrais.logradouro =
          data.end_logradouro;

        if (data.tipo_pessoa && data.tipo_pessoa == "JURIDICA") {
          this.$marketplace_consumidor.cadastro.dados_cadastrais.cnpj =
            data.cnpj;
          this.$marketplace_consumidor.cadastro.dados_cadastrais.razao_social =
            data.razao_social;
          return;
        }

        this.$marketplace_consumidor.cadastro.dados_cadastrais.nome = data.nome;
        this.$marketplace_consumidor.cadastro.dados_cadastrais.dt_nascimento =
          this.$config.convertDataBR(data.dt_nascimento);
        this.$marketplace_consumidor.cadastro.dados_cadastrais.documento =
          data.documento;
        return;
      }
      this.$router.push({
        name: "marketPlaceConsumerSettings",
        params: { type: "cadastrar" },
      });
    },
  },
};
